import { NormalButton, NormalDate } from "component/common";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { AiOutlineRight, AiOutlineDown } from "react-icons/ai";
import { bindActionCreators } from "redux";

export class StudioClass extends Component {
  state = {};

  handleChange = (link) => {
    this.props.history.push(link);
    console.log(link, "Link");
  };

  render() {
    const Heading = [
      {
        title: "Reports",
        link: "/admin/studio/reports",
      },
      {
        title: "Dress Rental",
        link: "/admin/studio/dress-rental",
      },
    ];
    return (
      <div className="col-md-12 ">
        <div className="container-fluid bg-white px-md-5 my-3">
          <div className="py-5">
            <p className="fs-16 mb-3">
              <span className="font-weight-bold px-1 ml-4 ">HOME</span>/Studio
            </p>
            {/* <h2 className="my-4 ml-4 main-title">Back End</h2>
            <p className="font-weight-normal fs-16 ml-4">
              See full list of your backend reports here
            </p>
            <div className="row my-3 d-flex ">
              <div className="col-md-4 font-weight-bold">
                <Navbar />
              </div>
            </div> */}

            <div className="card-head ">
              {Heading.map((item, index) => {
                const isActive = this.state.activeIndex === index;
                const hasChildren = item.children && item.children.length > 0;

                return (
                  // <div className="col-lg-6 ">
                  <div className="col-md-6 col-sm-12 " key={index}>
                    <div className="card ">
                      <div
                        className="card-body row d-flex justify-content-between align-items-center"
                        onClick={() => this.toggleDropdown(index)}
                      >
                        <div className="col-md-6 ">
                          <p className="card-title">{item.title}</p>
                          {/* <p>{item.time}</p> */}
                        </div>

                        <div className="col-md-6 col-sm-2 mt-2  text-center">
                          {hasChildren && isActive ? (
                            <AiOutlineDown />
                          ) : hasChildren && !isActive ? (
                            <AiOutlineRight />
                          ) : (
                            <NormalButton
                              backend={true}
                              label={"View"}
                              onClick={() => this.handleChange(item.link)}
                            />
                          )}
                        </div>
                      </div>
                      {isActive && (
                        <div className=" col-md-12 mb-2">
                          {console.log(item.children, "itemChild")}
                          {item.children &&
                            item.children.map((child, index) => (
                              <div className="col-md-12 mt-2 d-flex justify-content-between align-items-center">
                                <div className="col-md-6">
                                  <p className="child-title">{child.title}</p>
                                </div>
                                <div className="col-md-6">
                                  <NormalButton
                                    backend_child={true}
                                    label={"View"}
                                    onClick={() =>
                                      this.handleChange(child.link)
                                    }
                                  />
                                </div>
                                {/* <p>{item.time}</p> */}
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  </div>
                  // </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export const Studio = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(StudioClass)
);
